/**
 * Formats a date string into a standardized UTC key format (YYYY-MM-DD)
 * @param dateString The date string to format
 * @returns Formatted date key or 'invalid' if date is invalid
 */
export const getUTCDateKey = (dateString: string): string => {
  if (!dateString || isNaN(new Date(dateString).getTime())) {
    return 'invalid';
  }

  const d = new Date(dateString);
  const year = d.getUTCFullYear();
  const month = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Formats a date key for display with a fixed time to avoid timezone issues
 * @param dateKey The date key in YYYY-MM-DD format
 * @returns Formatted date string or null if date is invalid
 */
export const formatDateKeyForDisplay = (dateKey: string): string | null => {
  if (dateKey === 'invalid' || isNaN(new Date(`${dateKey}T12:00:00`).getTime())) {
    return null;
  }
  const date = new Date(`${dateKey}T12:00:00`);
  return date.toLocaleDateString('pt-BR');
};